/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-queues-page-grid .ui-grid-cell[data-property=processName] .ui-grid-cell-content{height:100%;display:flex;align-items:center}.ui-queues-page-grid .ui-grid-cell[data-property=processName] .ui-grid-cell-content mat-icon{margin-right:5px;min-width:24px}.ui-queues-page-grid .ui-grid-cell[data-property=processName] .ui-grid-cell-content .disabled{opacity:.4}"];
export { styles as styles };
